<template>
  <v-container fluid fill-height>
    <v-slide-y-transition mode="out-in">
      <v-layout row wrap>
        <v-flex d-flex xs12>
          <v-layout column>
            <v-flex d-flex>
              <v-card style="margin-top:20px">
                <v-card-text>
                  <h3 style="text-align: left;margin-bottom: 10px">My Bookings</h3>
                  <v-divider divider: true></v-divider>
                  <v-layout row wrap>
                    <p style="margin-top:20px;text-align: left"><v-btn v-on:click="sho1(); activate(1);" :class="[(active_el === 1 ) ? 'active_el' : 'default']" flat>My Booking</v-btn> / <v-btn v-on:click="sho2(); activate(2); " :class="[(active_el === 2 ) ? 'active_el' : 'default']" flat>Template</v-btn></p>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs3 child-flex>
                    </v-flex>
                    <v-flex xs3 child-flex></v-flex>
                    <v-flex xs6 child-flex>
                      <v-layout row wrap>
                        <v-text-field
                          label="Search"
                        ></v-text-field>
                        <v-btn class="primary" flat style="margin-top:10px;"><v-icon dark>search</v-icon></v-btn>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-flex style="text-align: left">
                    <v-data-table
                      :headers="headers"
                      :items="desserts"
                      class="elevation-1"
                      v-show="show1"
                      style="width:1200px"
                    >
                      <template slot="items" slot-scope="props">
                        <td>{{ props.item.no}}</td>
                        <td class="text-xs-left">{{ props.item.salesorderno}}</td>
                        <td class="text-xs-left">{{ props.item.bookingno}}</td>
                        <td class="text-xs-left">{{ props.item.status}}</td>
                        <td class="text-xs-left"><v-layout row wrap><a style="margin-left: 20px;margin-right: 20px">CSV</a> | <a style="margin-left: 20px;margin-right: 20px">PDF</a> | <a style="margin-left: 20px;margin-right: 20px">Print</a></v-layout></td>
                      </template>
                    </v-data-table>
                  </v-flex>
                  <v-flex style="text-align: left">
                    <v-data-table
                      :headers="headers1"
                      :items="desserts1"
                      class="elevation-1"
                      v-show="show2"
                      style="width:1200px"
                    >
                      <template slot="items" slot-scope="props">
                        <td>{{ props.item.no}}</td>
                        <td class="text-xs-left">{{ props.item.templatename}}</td>
                        <td class="text-xs-left">{{ props.item.templatedate}}</td>
                        <td class="text-xs-left"><v-layout row wrap><v-btn class="primary" style="margin-left: 20px;margin-right: 20px">Create Booking</v-btn> | <a style="margin-left: 20px;margin-right: 20px">Delete</a></v-layout></td>
                      </template>
                    </v-data-table>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      active_el: 1,
      dropdown_list: [1, 2, 3, 4, 5],
      headers: [
        {
          text: '#',
          align: 'left',
          value: 'no'
        },
        { text: 'Sales Order No', value: 'salesorderno' },
        { text: 'Booking No', value: 'bookingno' },
        { text: 'Status', value: 'status' },
        { text: 'Action Table', value: 'actiontable' }
      ],
      desserts: [
        {
          no: '1',
          salesorderno: '',
          bookingno: '',
          status: ''
        },
        {
          no: '2',
          salesorderno: '',
          bookingno: '',
          status: ''
        },
        {
          no: '3',
          salesorderno: '',
          bookingno: '',
          status: ''
        }
      ],
      headers1: [
        {
          text: '#',
          align: 'left',
          value: 'no'
        },
        { text: 'Template Name', value: 'templatename' },
        { text: 'Template Date', value: 'templatedate' },
        { text: 'Action Table', value: 'actiontable' }
      ],
      desserts1: [
        {
          no: '1',
          templatename: '',
          templatedate: ''
        },
        {
          no: '2',
          templatename: '',
          templatedate: ''
        },
        {
          no: '3',
          templatename: '',
          templatedate: ''
        }
      ],
      show1: true,
      show2: false,
      switch1: true,
      dialog: false,
      dialog1: false
    }
  },
  mounted () {
    console.log('wynumtrack page')
  },
  methods: {
    sho1 () {
      this.show1 = true
      this.show2 = false
    },
    sho2 () {
      this.show2 = true
      this.show1 = false
    },
    activate (el) {
      this.active_el = el
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.active_el {
  background-color: #00C853;
  color: white;
}

</style>



// WEBPACK FOOTER //
// src/components/Mybookings.vue